import _ from 'underscore';
import $ from 'jquery';
import URI from 'urijs';
import Backbone from '@polleverywhere/backbone';
import env from '@polleverywhere/core/lib/env';

var timingComplete = function timingComplete(self) {
  if (self._timingComplete) {
    return self._timingComplete;
  }

  self._timingComplete = $.Deferred();

  if (self.timing) {
    var timingCompleteInterval = setInterval(function () {
      if (self.timing.loadEventEnd > 0) {
        clearInterval(timingCompleteInterval);
        return self._timingComplete.resolve();
      }
    }, 1000);
  } else {
    self._timingComplete.reject();
  }

  return self._timingComplete;
};

var trackBaseTimings = function trackBaseTimings(self) {
  trackTiming(self, 'Total Time', totalTime(self));
  trackTiming(self, 'Network Time', networkTime(self));
  trackTiming(self, 'Browser Time', browserTime(self));
  trackTiming(self, 'Server Time', serverTime(self));
  trackTiming(self, 'DOM Loading', domLoading(self));
  trackTiming(self, 'DOM Interactive', domInteractive(self));
  trackTiming(self, 'DOM Loaded', domLoaded(self));
  trackTiming(self, 'DOM Complete', domComplete(self));
  trackTiming(self, 'DNS Lookup Time', dnsLookupTime(self));
  trackTiming(self, 'Connection Time', connectTime(self));
};

var trackResourceLoadTimes = function trackResourceLoadTimes(self, urlType, resourceType) {
  var data = [];
  /**
   * Safari doesn't support resource timing and Firefox requires
   * the user to turn on a flag in their browser. WTF??
   */

  if ((env != null ? env.get(urlType) : undefined) && (self.performance != null ? self.performance.getEntriesByType : undefined)) {
    var baseUrl = env.get(urlType).toString();
    var resources = self.performance != null ? self.performance.getEntriesByType('resource') : undefined;
    resources.forEach(function (r) {
      if (r.name.indexOf(baseUrl) >= 0) {
        var url = URI(r.name);
        var additionalData = {
          fileType: url.suffix(),
          path: url.pathname()
        }; // round this guy because duration is a float

        var duration = Math.round(r.duration);
        trackTiming(self, resourceType + " Load Time", duration, additionalData);
        return data.push({
          time: duration,
          fileType: url.suffix(),
          path: url.pathname()
        });
      }
    });
  }

  return data;
};

var trackTiming = function trackTiming(self, variable, time, opts) {
  if (opts === void 0) {
    opts = {};
  }

  return self.app.trigger('performance', variable, parseInt(time), opts);
};

var totalTime = function totalTime(self) {
  return self.timing.loadEventEnd - self.timing.navigationStart;
}; // high level breakdowns


var networkTime = function networkTime(self) {
  return self.timing.connectEnd - self.timing.navigationStart;
};

var serverTime = function serverTime(self) {
  return self.timing.responseEnd - self.timing.requestStart;
};

var browserTime = function browserTime(self) {
  return self.timing.loadEventEnd - self.timing.domLoading;
}; // dom timings


var domLoading = function domLoading(self) {
  return self.timing.domLoading - self.timing.navigationStart;
};

var domInteractive = function domInteractive(self) {
  return self.timing.domInteractive - self.timing.navigationStart;
};

var domLoaded = function domLoaded(self) {
  return self.timing.domContentLoadedEventEnd - self.timing.navigationStart;
};

var domComplete = function domComplete(self) {
  return self.timing.domComplete - self.timing.navigationStart;
}; // misc timings


var dnsLookupTime = function dnsLookupTime(self) {
  return self.timing.domainLookupEnd - self.timing.domainLookupStart;
};

var connectTime = function connectTime(self) {
  return self.timing.connectEnd - self.timing.connectStart;
};

var timingData = function timingData(self) {
  return {
    total_time: totalTime(self),
    network_time: networkTime(self),
    browser_time: browserTime(self),
    server_time: serverTime(self),
    dom_loading: domLoading(self),
    dom_interactive: domInteractive(self),
    dom_loaded: domLoaded(self),
    dom_complete: domComplete(self),
    dns_lookup_time: dnsLookupTime(self),
    connection_time: connectTime(self)
  };
};
/**
 * Service that aggregates browser timings and resource loading times
 *
 * ![](https://monosnap.com/file/pisJ2ZA816p3cena0GgdoPmBVR9G1f.png)
 *
 * @see http://www.w3.org/TR/navigation-timing/#processing-model
 *
 * @event timing
 *   @param {Object} data Timing data
 *   @param {Number} data.total_time navStart to loadEventEnd
 *   @param {Number} data.network_time navStart to connectEnd
 *   @param {Number} data.browser_time domLoading to loadEventEnd
 *   @param {Number} data.server_time requestStart to requestEnd
 *   @param {Number} data.dom_loading navStart to domLoading
 *   @param {Number} data.dom_interactive navStart to domInteractive
 *   @param {Number} data.dom_loaded navStart to domContentLoadedEventEnd
 *   @param {Number} data.dom_complete navStart to domComplete
 *   @param {Number} data.dns_lookup_time Time spend doing domain lookup
 *   @param {Number} data.connection_time connectStart to connectEnd
 *   @param {Array} data.resources Array of resource load times
 *
 */


var LoadTime = function LoadTime(app, performance) {
  var _this = this;

  if (performance === void 0) {
    performance = {};
  }

  this.app = app;
  this.performance = performance;

  _.extend(this, Backbone.Events);

  this.timing = this.performance.timing;
  timingComplete(this).done(function () {
    /**
     * Call this only after timing is done because it needs the latest
     * timing values
     */
    trackBaseTimings(_this); // try to wait until the requests are done

    _.delay(function () {
      var data = timingData(_this);
      var apiData = (env != null ? env.get('proxy_enabled') : undefined) ? trackResourceLoadTimes(_this, 'root_url', 'API') : trackResourceLoadTimes(_this, 'api_url', 'API');
      data.resources = {
        assets: trackResourceLoadTimes(_this, 'cdn_url', 'CDN Asset'),
        api: apiData
      };

      _this.trigger('timing', data);
    }, 7000);
  });
};

export { LoadTime as default };